import { clearFilterStatesByPageContext } from '../lib/clear-local-storage';

let scrollToDepsPromise = null;

function getScrollToDeps() {
	if (!scrollToDepsPromise) {
		scrollToDepsPromise = Promise.all([
			import('gsap'),
			import('gsap/ScrollToPlugin'),
		]).then(([gsapModule, scrollToPluginModule]) => {
			const { gsap } = gsapModule;
			const { ScrollToPlugin } = scrollToPluginModule;
			gsap.registerPlugin(ScrollToPlugin);
			return gsap;
		});
	}

	return scrollToDepsPromise;
}

export default function init() {
	// Add class after first paint to avoid triggering transitions during initial layout
	const setReady = () => {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				document.documentElement.classList.add('is-ready');
			});
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', setReady, { once: true });
	} else {
		// DOM already parsed
		setReady();
	}

	// Clear saved filters for sections that are absent on the current page.
	// Example: no [data-postype="team"] on page -> remove filterState_team.
	clearFilterStatesByPageContext(document);

	//Anchors
	const siteHeader = document.querySelector("#site-header");
	const links = document.querySelectorAll("a");
	const currentUrl = window.location.origin + window.location.pathname;

	links.forEach((link) => {
		link.addEventListener("click", (event) => {
			const targetUrl = link.getAttribute("href");
			const targetHash = targetUrl.includes("#") ? targetUrl.split("#")[1] : null;

			if (!targetUrl || !targetHash) return;

			const isSamePage = targetUrl.startsWith("#") || targetUrl.startsWith(currentUrl + "#");

			if (link.getAttribute("target") === "_blank") return;

			event.preventDefault();

			setTimeout(() => {
				if (!isSamePage) {
					window.location.href = targetUrl;
				} else {
					const targetElement = document.getElementById(targetHash);
					if (targetElement) {
						getScrollToDeps().then((gsap) => {
							gsap.to(window, {
								duration: 1.5,
								scrollTo: { y: targetElement, offsetY: siteHeader?.offsetHeight || 0 },
								ease: "power2.inOut",
							});
						});
					}
				}
			}, siteHeader.classList.contains("opened") ? 1500 : 0);
		});
	});
}
